import React from 'react'
import styled from 'styled-components'
import { SvgAlert } from '@ntuctech/devex-tangram/Icon'
import { SCREEN_SIZE } from '../../lib/Media'

const StyledBox = styled.div`
  align-items: center;
  background-color: #fee7ed;
  border-radius: 0.125rem;
  border: 0.0625rem solid #c10b3a;
  color: #c10b3a;
  display: flex;
  height: 2rem;
  margin: 0 1rem;
  font-size: 0.75rem;
  padding: 0.75rem;

  svg {
    margin-right: 0.2rem;
  }

  &[data-hidden='true'] {
    display: none;
  }

  ${SCREEN_SIZE.From.Tablet} {
    transform: translateY(1.7rem);
  }
`

const SessionTimeoutNotification = ({ hidden }) => {
  return (
    <StyledBox data-hidden={hidden}>
      <SvgAlert size="s" color="#c10b3a" />
      Your user session has expired. Please login again.
    </StyledBox>
  )
}

export default SessionTimeoutNotification
